exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card.wide-content .pagination {\n  padding: 0 22px;\n}\n.pagination .per-page {\n  position: absolute;\n  width: 100%;\n  right: 0;\n  margin-right: 22px;\n  color: #085FCE;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n}\n.pagination .per-page .ant-select-selection {\n  height: 30px;\n  display: flex;\n  align-items: center;\n}", ""]);

// exports
